import React, { useEffect, useState } from 'react';
import ApplicationState from 'store/interfaces';
import TitleDivider from 'components/TitleDivider';
import GenericForm from 'skyone-lib/lib/GenericForm';
import {
  EnvironmentFields,
  FormModelProps,
  ModelFormFields,
  ProviderResourcesProps,
} from 'modules/environments/interfaces';
import { FormikErrors } from 'formik';
import { applyI18n } from 'utils/helpers';
import i18n from 'i18n';
import { FormControlLabel, Grid, Switch, makeStyles } from '@material-ui/core';

import { connect } from 'react-redux';
import { getProviderResourcesRequest } from 'modules/environments/actions';
import styles from './styles';
import awsScreenFields from './awsFields';
import { createFieldOptions } from '../utils';

const useStyles = makeStyles(styles);

interface AwsFormProps {
  values: ModelFormFields | FormModelProps;
  errors: FormikErrors<ModelFormFields | FormModelProps>;
  providerResources: ProviderResourcesProps;
  environment: EnvironmentFields | null;
  getProviderResourcesRequest: (props) => void;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void;
}

const mapAwsFields = {
  'provider_data.key_pair': 'keypairs',
  'provider_data.primary_zone': 'zones',
  'provider_data.secondary_zone': 'zones',
  'provider_data.image_id': 'images',
  'provider_data.security_group': 'securityGroups',
  'provider_data.flavor': 'flavors',
};

const AwsForm = ({
  values,
  errors,
  providerResources,
  environment,
  getProviderResourcesRequest,
  setFieldValue,
}: AwsFormProps) => {
  const classes = useStyles();
  const [awsFields, setAwsFields] = useState<any>([]);

  const makeFields = () =>
    awsScreenFields.map(field => {
      if (mapAwsFields[field?.stateKey]) {
        return createFieldOptions(field, mapAwsFields, providerResources);
      }
      return field;
    });

  useEffect(() => {
    setAwsFields(makeFields());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [providerResources]);

  useEffect(() => {
    getProviderResourcesRequest({
      environment,
      modelType: environment?.publication?.type,
      reloadEnvProviderResources:
        providerResources.environment_uuid !== environment?.environment_uuid,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [environment]);

  return (
    <>
      <TitleDivider overrideClasses={{ title: { marginTop: 8 } }}>
        {'AWS:'}
      </TitleDivider>
      <GenericForm
        fields={values}
        screenFields={applyI18n(awsFields, i18n.language)}
        setFieldValue={setFieldValue}
        errors={errors}
      />
      <Grid item xs={12}>
        <FormControlLabel
          classes={{ label: classes.switchLabel }}
          control={
            <Switch
              size="small"
              id="toggle-is-spot"
              checked={
                values?.provider_data !== null
                  ? values.provider_data.is_spot
                  : false
              }
              onChange={(
                event: React.ChangeEvent<HTMLInputElement>,
                checked: boolean
              ) => setFieldValue('provider_data.is_spot', checked)}
              classes={{ colorSecondary: classes.switchChecked }}
            />
          }
          label="Is spot"
        />
      </Grid>
    </>
  );
};

const mapStateToProps = ({
  environments: { providerResources, environmentSelected },
}: ApplicationState) => ({
  environment: environmentSelected,
  providerResources,
});

export default connect(mapStateToProps, {
  getProviderResourcesRequest,
})(AwsForm);
